import httpService from 'services/http/http.service';
import ApiUrl from 'enum/api-url.enum';

function getLatestNews() {
  return httpService.get(ApiUrl.LATESTNEWS);
}

const obj = { getLatestNews };

export default obj;
